'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BlueCaretArrowButton = require('./components/BlueCaretArrowButton.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BlueCaretArrowButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/buttons/lib/components/blue-caret-arrow/index.js
// module id = 342
// module chunks = 0 1 2 3 4 5 6 7 8 9 10